import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { BagItem } from "@/types/bag";

interface BagStoreState {
	items: BagItem[];
	paymentMethod: string;
	addItem: (item: BagItem) => void;
	removeItem: (id: string) => void;
	updateQuantity: (id: string, quantity: number) => void;
	resetBag: () => void;
}

export const useBagStore = create<BagStoreState>()(
	persist(
		(set, get) => ({
			items: [],
			paymentMethod: "",
			addItem: (item) => {
				if (!item.vendorId)
					throw new Error("BagItem must have vendorId");
				// Try to get productName from item or fallback to id
				const productName = item.productName || item.id;
				const newItem = { ...item, productName };
				const exists = get().items.find(i => i.id === item.id);
				if (exists) {
					set({
						items: get().items.map(i =>
							i.id === item.id ? { ...i, quantity: i.quantity + item.quantity, productName } : i
						)
					});
				}
				else {
					set({ items: [...get().items, newItem] });
				}
			},
			removeItem: id => set({ items: get().items.filter(i => i.id !== id) }),
			updateQuantity: (id, quantity) => set({ items: get().items.map(i => i.id === id ? { ...i, quantity } : i) }),
			resetBag: () => set({ items: [], paymentMethod: "" })
		}),
		{ name: "intasida/bag-store" }
	)
);
